import request from '@/utils/request'

let BASEROOT          = '/visitor/v2'

// 获取足迹列表
export function getActorTrailList(query) {
  return request({
    url: BASEROOT + '/actorTrail/actorTrailList',
    method: 'post',
    data: query
  })
}

//浏览记录 客商
export function listPerson(query) {
  return request({
    url: BASEROOT + '/trail/listVisitor',
    method: 'post',
    data: query
  })
}

//浏览记录 展商
export function listActor(query) {
  return request({
    url: BASEROOT + '/trail/listActor',
    method: 'post',
    data: query
  })
}

//浏览记录 展品
export function listProduct(query) {
  return request({
    url: BASEROOT + '/trail/listProduct',
    method: 'post',
    data: query
  })
}